import { Wrench } from "lucide-react";
import { eur } from "./format";
import { useT } from "./i18n";

export function QuoteLines({ items, totals, notes }) {
  const { t } = useT();
  return (
    <div className="ds-card p-5" data-testid="quote-lines">
      <div className="flex items-center gap-2">
        <Wrench size={15} className="text-[#6E8B3D]" />
        <h2 className="font-display font-bold text-base md:text-lg">{t("your_repair")}</h2>
      </div>
      <p className="text-xs text-[#525252] mt-0.5">{t("lines_intro")}</p>
      <div className="mt-3 divide-y divide-[#EEEEEA]">
        {items.map((it, i) => (
          <div key={i} className="py-2.5 flex items-start justify-between gap-3" data-testid={`quote-line-${i}`}>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-[#111110]">{it.name}</div>
              {it.description && <div className="text-xs text-[#525252] mt-0.5">{it.description}</div>}
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#525252] mt-0.5">
                {[
                  it.quantity !== 1 ? `${it.quantity} × ${eur(it.unit_price)}` : "",
                  it.discount_pct ? `-${it.discount_pct}%` : "",
                  it.warranty_months ? t("warranty_months", { n: it.warranty_months }) : "",
                ].filter(Boolean).join(" · ")}
              </div>
            </div>
            <div className="font-mono text-sm font-bold shrink-0">{eur(it.line_total)}</div>
          </div>
        ))}
        {items.length === 0 && <div className="py-4 text-sm text-[#525252] text-center">{t("no_lines")}</div>}
      </div>
      <div className="mt-3 pt-3 border-t border-[#E5E5E0] flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">{t("repair_total")}</span>
        <span className="font-display font-black text-lg" data-testid="quote-repair-total">{eur(totals.total)}</span>
      </div>
      {notes && (
        <div className="mt-3 text-xs text-[#525252] whitespace-pre-line border-t border-[#EEEEEA] pt-3" data-testid="quote-notes">{notes}</div>
      )}
    </div>
  );
}
